import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleRightSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-simple-right-square"><path fillRule="evenodd" clipRule="evenodd" d="M21 3.75C21 3.33579 20.6642 3 20.25 3H3.75C3.33579 3 3 3.33579 3 3.75V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V3.75ZM15 4.5V19.5H4.5V4.5H15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSidebarSimpleRightSquare;
